'use client'

import { RefreshRouteOnSave as PayloadLivePreview } from '@payloadcms/live-preview-react'
import { useRouter, useSearchParams } from 'next/navigation'
import { useEffect, useCallback } from 'react'

import { getClientSideURL } from '@systhemaui/payload/utils/getURL'

const LivePreviewListener: React.FC = () => {
  const router = useRouter()
  const searchParams = useSearchParams()

  const handleRefresh = useCallback(() => {
    window.dispatchEvent(new CustomEvent('payloadRefresh'))
    router.refresh()
  }, [router])

  useEffect(() => {
    const isLivePreview = searchParams.get('__livePreview') === 'true'
    if (isLivePreview) {
      document.body.classList.add('in-live-preview')
      document.body.classList.add('aos-disable-children')

      const preventLinkClicks = (e: MouseEvent) => {
        let element = e.target as HTMLElement
        while (element) {
          if (element.tagName === 'A') {
            e.preventDefault()
            break
          }
          element = element.parentElement as HTMLElement
        }
      }

      document.addEventListener('click', preventLinkClicks, true)

      return () => {
        document.removeEventListener('click', preventLinkClicks, true)
      }
    } else {
      document.body.classList.remove('in-live-preview')
      document.body.classList.remove('aos-disable-children')
    }
  }, [searchParams])

  return <PayloadLivePreview refresh={handleRefresh} serverURL={getClientSideURL()} />
}

export default LivePreviewListener
